









import Vue from 'vue';
import { OpenUpdateAccountHoldScreen } from '@/mixins/get-content-mixins';
import SettingWrapper from '../setting-wrapper.component.vue';
import { ExtendMixins } from '@/services';

export default ExtendMixins(
  OpenUpdateAccountHoldScreen,
).extend({
  name: 'AccountStatus',
  props: {
    onHold: {
      type: Boolean,
      required: true,
    },
    accountId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    accountStatus(): string {
      return this.onHold
        ? this.$options.filters.t([
            'account-settings_label_on-hold',
            'global_on-hold',
          ])
        : this.$options.filters.t([
            'account-settings_label_active',
            'global_active',
          ]);
    },
    accountStatusCTA(): string {
      return this.onHold
        ? this.$options.filters.t([
            'account-settings_action_release-hold',
            'global_release-hold',
          ])
        : this.$options.filters.t([
            'account-settings_action_set-hold',
            'global_set-hold',
          ]);
    },
  },
  methods: {
    updateAccountHold(): void {
      this.openUpdateAccountHoldScreen({
        accountId: this.accountId,
        accountStatus: this.accountStatus,
      });
    },
  },
  components: {
    SettingWrapper,
  },
});
